import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import * as moment from 'moment';
import { Moment } from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-request-date-filter',
    templateUrl: './request-date-filter.component.html',
    styleUrls: ['./request-date-filter.component.scss'],
    animations: fuseAnimations,
})
export class RequestDateFilterComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    selectedFilter: {
        name: string;
        translationKey: string;
        isUserAttribute: boolean;
        attributeName?: string;
    };

    @Output()
    addedToList = new EventEmitter<IChoosenFilterInterface[]>();

    list: IChoosenFilterInterface[] = [];
    dateRange = new FormGroup({
        startDate: new FormControl<Moment | null>(null),
        endDate: new FormControl<Moment | null>(null),
    });

    private _rangePickerOpen: boolean = false;

    onRangePickerOpened(): void {
        this._rangePickerOpen = true;
    }

    onRangePickerClosed(): void {
        this._rangePickerOpen = false;
        this._emitCompletedRangeIfChanged();
        this._initValues();
    }

    private _emitCompletedRangeIfChanged(): void {
        const value = this.dateRange.getRawValue() as { startDate: Moment | null; endDate: Moment | null };
        if (!value?.startDate || !value?.endDate || !this.selectedFilter?.name) {
            return;
        }

        const existing = this.list.find((f) => f.entity.id === this.selectedFilter.name);
        if (
            existing &&
            moment(existing.rangeValue1).isSame(value.startDate, 'day') &&
            moment(existing.rangeValue2).isSame(value.endDate, 'day')
        ) {
            return;
        }

        this.addedToList.emit([
            ...this.list.filter((item) => item.entity.id !== this.selectedFilter.name),
            {
                entity: { id: this.selectedFilter.name, type: this.selectedFilter.name as any },
                valueToShow: `${this._translateService.instant(this.selectedFilter.translationKey)}: ${moment(value.startDate).format(
                    'YYYY-MM-DD'.replace(/-/g, '/')
                )} - ${moment(value.endDate).format('YYYY-MM-DD'.replace(/-/g, '/'))}`,
                attributeName: this.selectedFilter.attributeName || this.selectedFilter.name,
                isRange: true,
                rangeValue1: moment(value.startDate).format('YYYY-MM-DD'),
                rangeValue2: moment(value.endDate).format('YYYY-MM-DD'),
            },
        ]);
    }

    private _initValues(): void {
        if (this._rangePickerOpen || !this.selectedFilter?.name) {
            return;
        }

        const existingFilter = this.list.find((filter) => filter.entity.id === this.selectedFilter.name);
        if (existingFilter) {
            const selected = {
                startDate: moment(existingFilter.rangeValue1),
                endDate: moment(existingFilter.rangeValue2),
            };

            this.dateRange.setValue(selected, { emitEvent: false });
        }
    }

    constructor(private _allUsersService: AllUsersApiService, private _translateService: TranslateService) {
        super();
    }

    ngOnInit(): void {
        this._allUsersService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.list = filters;
            this._initValues();
        });
    }
}
